import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "items-center justify-between flex ResponsiveStartAudit" }
const _hoisted_3 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "table-section" }
const _hoisted_6 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_7 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_8 = { class: "formcontainer flex flex-col" }
const _hoisted_9 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_10 = { class: "w-1/2 pr-2" }
const _hoisted_11 = { class: "w-1/2 pr-2" }
const _hoisted_12 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "w-full mt-3" }
const _hoisted_16 = { class: "w-full mt-3" }
const _hoisted_17 = { class: "w-1/2 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal page-fill' : 'pt-3 px-5 pb-2 page-fill')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[8] || (_cache[8] = [
            _createElementVNode("h1", null, "Audit Findings", -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "filterButton flex",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "filterIcon"
          }, null, -1),
          _createTextVNode(" Filters ")
        ]))
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mt-5 ResponsiveStartAudit" }, [
      _createElementVNode("p", { class: "headerText" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_tableData, {
        class: "flex-1 min-h-0",
        tableRowData: _ctx.tableRow,
        headersData: _ctx.mainHeaders
      }, null, 8, ["tableRowData", "headersData"])
    ]),
    (_ctx.showPopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.showPopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _cache[11] || (_cache[11] = _createElementVNode("h1", null, "Findings", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "controllabel" }, "Framework", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "inputboxstyling",
                        disabled: "",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ActionObj.frameworks) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.ActionObj.frameworks]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "controllabel" }, "Control Number", -1)),
                      _withDirectives(_createElementVNode("input", {
                        class: "inputboxstyling",
                        disabled: "",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ActionObj.frameWorkControl) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.ActionObj.frameWorkControl]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "controllabel" }, "Finding Category", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "inputboxstyling cursor-pointer",
                        disabled: "",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ActionObj.findingCategory) = $event))
                      }, [
                        _cache[14] || (_cache[14] = _createElementVNode("option", {
                          value: "",
                          selected: "",
                          disabled: "",
                          hidden: ""
                        }, "Please select one", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.findingCategoryData, (i) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: i.id,
                            key: i.id
                          }, _toDisplayString(i.value), 9, _hoisted_14))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.ActionObj.findingCategory]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "controllabel" }, "Findings", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "inputboxstyling resize-none",
                      disabled: "",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ActionObj.findingComment) = $event)),
                      placeholder: "Findings",
                      rows: "3"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.ActionObj.findingComment,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", { class: "controllabel" }, "Finding related to Evidence", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "inputboxstyling resize-none",
                      disabled: "",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ActionObj.findingEvidence) = $event)),
                      placeholder: "Finding related to Evidence"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.ActionObj.findingEvidence,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "controllabel" }, "Control Audit Result", -1)),
                    _withDirectives(_createElementVNode("input", {
                      class: "inputboxstyling cursor-pointer",
                      disabled: "",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ActionObj.auditResult) = $event)),
                      type: "text",
                      placeholder: "Default will be Team Owner"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.ActionObj.auditResult,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 2))
}